module.exports = __webpack_public_path__ + "img/1570994089.5c1e521e.jpg";